/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AGREEMENT_BASE_ONLY_HOST",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_ADMIN_CANNOT_BE_POOL",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_DISTRIBUTE_FOR_OTHERS_NOT_ALLOWED",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_DISTRIBUTE_FROM_ANY_ADDRESS_NOT_ALLOWED",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_FLOW_DOES_NOT_EXIST",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_INSUFFICIENT_BALANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_NON_CRITICAL_SENDER",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_NOT_POOL_ADMIN",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_NO_NEGATIVE_FLOW_RATE",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_NO_ZERO_ADDRESS_ADMIN",
        type: "error",
    },
    {
        inputs: [],
        name: "GDA_ONLY_SUPER_TOKEN_POOL",
        type: "error",
    },
    {
        inputs: [],
        name: "OUT_OF_GAS",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int256",
                name: "bufferDelta",
                type: "int256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBufferAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalBufferAmount",
                type: "uint256",
            },
        ],
        name: "BufferAdjusted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        name: "CodeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "distributor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int96",
                name: "oldFlowRate",
                type: "int96",
            },
            {
                indexed: false,
                internalType: "int96",
                name: "newDistributorToPoolFlowRate",
                type: "int96",
            },
            {
                indexed: false,
                internalType: "int96",
                name: "newTotalDistributionFlowRate",
                type: "int96",
            },
            {
                indexed: false,
                internalType: "address",
                name: "adjustmentFlowRecipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int96",
                name: "adjustmentFlowRate",
                type: "int96",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "FlowDistributionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "distributor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "InstantDistributionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "connected",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "PoolConnectionUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        name: "PoolCreated",
        type: "event",
    },
    {
        inputs: [],
        name: "SLOTS_BITMAP_LIBRARY_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SUPERFLUID_POOL_DEPLOYER_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "agreementType",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "Time",
                        name: "_settled_at",
                        type: "uint32",
                    },
                    {
                        internalType: "FlowRate",
                        name: "_flow_rate",
                        type: "int128",
                    },
                    {
                        internalType: "Value",
                        name: "_settled_value",
                        type: "int256",
                    },
                ],
                internalType: "struct BasicParticle",
                name: "p",
                type: "tuple",
            },
            {
                internalType: "Time",
                name: "t",
                type: "uint32",
            },
        ],
        name: "appendIndexUpdateByPool",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "memberAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "claimAll",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "bool",
                name: "doConnect",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "connectPool",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "connectPool",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "bool",
                        name: "transferabilityForUnitsOwner",
                        type: "bool",
                    },
                    {
                        internalType: "bool",
                        name: "distributionFromAnyAddress",
                        type: "bool",
                    },
                ],
                internalType: "struct PoolConfig",
                name: "config",
                type: "tuple",
            },
        ],
        name: "createPool",
        outputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "disconnectPool",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "distribute",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "int96",
                name: "requestedFlowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "distributeFlow",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "requestedAmount",
                type: "uint256",
            },
        ],
        name: "estimateDistributionActualAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
            {
                internalType: "int96",
                name: "requestedFlowRate",
                type: "int96",
            },
        ],
        name: "estimateFlowDistributionActualFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "actualFlowRate",
                type: "int96",
            },
            {
                internalType: "int96",
                name: "totalDistributionFlowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "contract ISuperfluidPool",
                name: "to",
                type: "address",
            },
        ],
        name: "getFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getNetFlow",
        outputs: [
            {
                internalType: "int96",
                name: "netFlowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
        ],
        name: "getPoolAdjustmentFlowInfo",
        outputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "flowHash",
                type: "bytes32",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "pool",
                type: "address",
            },
        ],
        name: "getPoolAdjustmentFlowRate",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBeacon",
                name: "superfluidPoolBeacon_",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "member",
                type: "address",
            },
        ],
        name: "isMemberConnected",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "isPatricianPeriod",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isPatricianPeriodNow",
        outputs: [
            {
                internalType: "bool",
                name: "isCurrentlyPatricianPeriod",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isPool",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "claimRecipient",
                type: "address",
            },
            {
                internalType: "int256",
                name: "amount",
                type: "int256",
            },
        ],
        name: "poolSettleClaim",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "realtimeBalanceOf",
        outputs: [
            {
                internalType: "int256",
                name: "rtb",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "buf",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedBuffer",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "realtimeBalanceOfNow",
        outputs: [
            {
                internalType: "int256",
                name: "availableBalance",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "buffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "superfluidPoolBeacon",
        outputs: [
            {
                internalType: "contract IBeacon",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidPool",
                name: "pool",
                type: "address",
            },
            {
                internalType: "address",
                name: "memberAddress",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "newUnits",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "updateMemberUnits",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60a06040523480156200001157600080fd5b5060405162005e0838038062005e08833981016040819052620000349162000046565b6001600160a01b031660805262000078565b6000602082840312156200005957600080fd5b81516001600160a01b03811681146200007157600080fd5b9392505050565b608051615d51620000b760003960008181610bd401528181610cb201528181610efa015281816136fd0152818161390c0152613a310152615d516000f3fe608060405234801561001057600080fd5b50600436106101e55760003560e01c806352d1902d1161010f5780639b2e48bc116100a2578063e8e7e2d111610071578063e8e7e2d1146104e4578063eccfc6a5146104f7578063f0b7b9151461050a578063fa48736d1461051d57600080fd5b80639b2e48bc1461047d578063c4d66de8146104ab578063c782eb9c146104be578063d2c0d542146104d157600080fd5b80636d1007a6116100de5780636d1007a6146104295780637730599e1461043c5780637b2cc0da146104625780639903ad381461047557600080fd5b806352d1902d146103b45780635437dd97146103ca5780635a6c6dbc146103e35780635cfd50d7146103f657600080fd5b80633fd4176a116101875780634d5c91ec116101565780634d5c91ec146103425780634e9ced571461036f5780634fe9c2911461038257806350d75d25146103ac57600080fd5b80633fd4176a146102dc5780634543b745146102f7578063469519541461031a5780634b839e0b1461032f57600080fd5b806330925b79116101c357806330925b791461026057806337bd42e014610273578063398c74e1146102ae5780633c56f090146102c157600080fd5b80630735d750146101ea5780630779d3651461021557806310dc879214610240575b600080fd5b6101fd6101f8366004614cec565b610530565b604051600b9190910b81526020015b60405180910390f35b610228610223366004614df8565b610556565b6040516001600160a01b03909116815260200161020c565b61025361024e366004614eb6565b61056b565b60405161020c9190614f6a565b61025361026e366004614f7d565b6108b8565b610286610281366004614fd1565b6108c7565b604080516001600160a01b0390941684526020840192909252600b0b9082015260600161020c565b6102536102bc366004615003565b610968565b61022873__$fb8a7211f6e0fb144ea3d242e9f7f2eec2$__81565b61022873__$97ed594b3f931187fb739dcb88a7dff641$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$fb8a7211f6e0fb144ea3d242e9f7f2eec2$__9063aeceff8e9060a401602060405180830381865af415801561257a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061259e919061537f565b6040805160018082528183019092529192506000919060208083019080368337019050509050600160001b816000815181106125dc576125dc61554f565b602090810291909101015260405163048620af60e11b81526001600160a01b0386169063090c415e9061261890859060009086906004016156d2565b600060405180830381600087803b15801561263257600080fd5b505af1158015612646573d6000803e3d6000fd5b5050505060006126558661413b565b90506001600160a01b038116156126d05760005a6040516335313c2160e11b81526001600160a01b03868116600483015291925090831690636a62784290602401600060405180830381600087803b1580156126b057600080fd5b505af19250505080156126c1575060015b6126ce576126ce81613d4f565b505b6040516001600160a01b03848116825280871691908816907f9c5d829b9b23efc461f9aeef91979ec04bb903feb3bee4f26d22114abfc7335b9060200160405180910390a350509392505050565b612726614c3f565b336001600160a01b0316836001600160a01b03166320bc44256040518163ffffffff1660e01b8152600401602060405180830381865afa15801561276e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612792919061537f565b6001600160a01b0316146127dc5760405162461bcd60e51b81526020600482015260116024820152701d5b985d5d1a1bdc9a5e9959081a1bdcdd607a1b6044820152606401611b5e565b604051632fd0a1cd60e21b8152339063bf428734906127ff908590600401614f6a565b602060405180830381865afa15801561281c573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612840919061539c565b61287a5760405162461bcd60e51b815260206004820152600b60248201526a0d2dcecc2d8d2c840c6e8f60ab1b6044820152606401611b5e565b604051631fb6491d60e11b81523390633f6c923a9061289d908590600401614f6a565b600060405180830381865afa1580156128ba573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611aff9190810190615785565b600080610b57858486612a46565b604051630a32470160e41b81526001600160a01b0380851660048301528316602482015260016044820152600160801b60648201526084810182905260009073__$97ed594b3f931187fb739dcb88a7dff641$__9063a32470109060a401602060405180830381865af415801561296b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610563919061588b565b604080514660208201526080918101829052600a60a0820152693837b7b626b2b6b132b960b11b60c08201526001600160a01b03808516606083015283169181019190915260009060e0016123bd565b6040805160018082528183019092526060916020808301908036833701905050905081600001516001600160a01b031660a0836020015163ffffffff16901b1760001b81600081518110612a3557612a3561554f565b602002602001018181525050919050565b6040805180820190915260008082526020820181905290612b14856001600160a01b0316636c2d9f2f30612a7a888861298f565b6040516001600160e01b031960e085901b1681526001600160a01b039092166004830152602482015260016044820152606401600060405180830381865afa158015612aca573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052612af2919081019061569e565b600081518110612b0457612b0461554f565b602002602001015160001c614181565b90969095509350505050565b604051631528e57f60e31b81526001600160a01b038085166004830152831660248201526001604482015263ffffffff8216606482015273__$97ed594b3f931187fb739dcb88a7dff641$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$97ed594b3f931187fb739dcb88a7dff641$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";
const isSuperArgs = (xs) => {
    return (typeof xs[0] === "string" ||
        Array.isArray(xs[0]) ||
        "_isInterface" in xs[0]);
};
export class GeneralDistributionAgreementV1__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            const [linkLibraryAddresses, signer] = args;
            super(_abi, GeneralDistributionAgreementV1__factory.linkBytecode(linkLibraryAddresses), signer);
        }
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$fb8a7211f6e0fb144ea3d242e9f7f2eec2\\$__", "g"), linkLibraryAddresses["contracts/agreements/gdav1/SuperfluidPoolDeployerLibrary.sol:SuperfluidPoolDeployerLibrary"]
            .replace(/^0x/, "")
            .toLowerCase());
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$97ed594b3f931187fb739dcb88a7dff641\\$__", "g"), linkLibraryAddresses["contracts/libs/SlotsBitmapLibrary.sol:SlotsBitmapLibrary"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
GeneralDistributionAgreementV1__factory.bytecode = _bytecode;
GeneralDistributionAgreementV1__factory.abi = _abi;
//# sourceMappingURL=GeneralDistributionAgreementV1__factory.js.map